import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import components from '@/components/lib'

const app_rc_scaner = createApp(App)

components.forEach(component => {
	app_rc_scaner.component(component.name, component)
})

app_rc_scaner.use(store).use(router).mount('#app')
